import React from 'react'
import { useContext } from "react";
import { SEOComponentContext } from "../../utils/component.utils";

export default function SectionHiddenIdComponent(){

    const componentContext = useContext(SEOComponentContext) || {componentContext:0}

    return <input type="hidden" id={`Section ${componentContext.sectionIndex} - ${componentContext.nuxeoTitle}`} value={componentContext.type}/>
}